export const SUBMIT_IN_STORE_CREDIT_REQUEST =
  "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST";
export const SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS =
  "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS";
export const SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE =
  "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE";

export const SUBMIT_ONLINE_CREDIT_REQUEST =
  "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST";
export const SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS =
  "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS";
export const SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE =
  "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE";

export const GET_LOAN_SIMULATION = "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION";
export const GET_LOAN_SIMULATION_SUCCESS =
  "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION_SUCCESS";
export const GET_LOAN_SIMULATION_FAILURE =
  "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION_FAILURE";
